import { Grid, Button, Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { MenuWithChildren } from '../../../types/menu';
import { desktopHeaderStyles } from './styles';

interface DropdownMenuListProps {
  menu: MenuWithChildren;
}
export const DropdownMenuList: React.FC<DropdownMenuListProps> = ({ menu }) => {
  return (
    <Grid container direction="row" spacing={4} sx={desktopHeaderStyles.dropdownListContainer} flexWrap="wrap">
      {menu.children &&
        menu.children.map((childMenu) => (
          <Grid xs={6} sx={desktopHeaderStyles.dropdownChildMenuContainer} item key={childMenu.id}>
            <Button
              sx={[desktopHeaderStyles.menuLink, desktopHeaderStyles.childMenuLink]}
              component={NavLink}
              color="secondary"
              to={childMenu.link}
              end
            >
              {childMenu.display_name}
            </Button>
            {childMenu.children && childMenu.children.length > 0 && (
              <Box sx={desktopHeaderStyles.dropdownSubChildMenuContainer}>
                <Grid container spacing={1.5} direction="column">
                  {childMenu.children.map((subChild) => (
                    <Grid sx={desktopHeaderStyles.subChildMenuLink} item xs key={subChild.id}>
                      <Button
                        color="secondary"
                        sx={desktopHeaderStyles.menuLink}
                        component={NavLink}
                        end
                        to={subChild.link}
                      >
                        {subChild.display_name}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Grid>
        ))}
    </Grid>
  );
};
